export const getRootHostname = () => {
  if (!window) {
    return undefined;
  }
  const { hostname } = window.location;
  const hostnameParts = hostname.split(".");

  return hostnameParts.slice(-2).join(".");
};
